export * from './brands.component'
